import { useTranslation } from "react-i18next";

import { RewardStatusType } from "../../../configs/models/constants";
import type { Status } from "../RewardCard";

export const RewardStatus = ({ status }: { status: Status }) => {
  const { t: translate } = useTranslation("translation");
  switch (status) {
  case RewardStatusType.VALID:
    return (
      <span className="rounded-full bg-success/20 px-2 py-1 text-success">
        {translate("valid")}
      </span>
    );

  case RewardStatusType.EXPIRED:
    return (
      <span className="rounded-full bg-danger/20 px-2 py-1 text-danger">
        {translate("expired")}
      </span>
    );

  case RewardStatusType.BURNED:
    return (
      <span className="rounded-full bg-danger/20 px-2 py-1 text-danger">
        {translate("burnt")}
      </span>
    );

  default:
    return null;
  }
};
